import { FormTemplate, Station, StatementTemplate } from '../types/api';

// Counts what backend parameters/parameter-refs.ts treats as a link: scale station params, gradebox form fields, highlighted ids;
// plus bank statements linked to the parameter (P2).
const arr = (v: unknown): any[] => (Array.isArray(v) ? v : []);

export function countParameterUsage(
  parameterId: string,
  stations: Station[],
  formTemplates: FormTemplate[],
  statements: Pick<StatementTemplate, 'sharedParameterId'>[] = [],
): { stations: number; forms: number; statements: number } {
  const stationCount = stations.filter(
    (s) =>
      arr(s.parameters).some((p) => p?.valueType === 'scale' && p.sharedParameterId === parameterId) ||
      arr((s.infoForEvaluator as any)?.includedParameterIds).includes(parameterId),
  ).length;
  const formCount = formTemplates.filter((f) =>
    arr(f.structure?.structure).some((b) => b?.type === 'gradebox' && b.sharedParameterId === parameterId),
  ).length;
  const statementCount = statements.filter((s) => s.sharedParameterId === parameterId).length;
  return { stations: stationCount, forms: formCount, statements: statementCount };
}
